import React from "react";
import stripTags from 'striptags';
import { tools } from "./tools";

export class RichTextEditorBase extends React.PureComponent {
	state = {
		focused: false,
		hasFocused: false,
		modules: {
			toolbar: tools,
		},
		readonlyModules: {
			toolbar: [],
		}
	};

    _editor = React.createRef()


	handleFocus = () => {
		this.setState({
			hasFocused: true,
			focused: true
		});
	};


	initialValue = this.props.value;
	handleBlur = () => {
		if (!this.initialValue) {
			this.initialValue = this.state.value;
			return;
		}

		this.setState({
			focused: false
		});
	};

	handleChange = (value) => {
		if (!this.state.hasFocused) { return; }
		this.props.onChange(value);
	};
    
    render() {
        return <React.Fragment />
    }
}